module.exports = __webpack_public_path__ + "static/media/document-not-available.6cbeecbb.png";